"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.noop = exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var DBL_CLICK_MAX_DELAY = 300;

var DoubleClickableListItem = function DoubleClickableListItem(_ref) {
  var disabled = _ref.disabled,
      selected = _ref.selected,
      onDoubleClick = _ref.onDoubleClick,
      onClick = _ref.onClick,
      className = _ref.className,
      item = _ref.item;
  var clickRef = (0, _react.useRef)(0);

  var handleClick = function handleClick() {
    if (disabled) {
      return;
    }

    var now = Date.now();

    if (now - clickRef.current <= DBL_CLICK_MAX_DELAY) {
      // double click
      onDoubleClick(item);
      clickRef.current = 0;
    } else {
      // single click
      onClick(item);
      clickRef.current = now;
    }
  };

  return /*#__PURE__*/_react["default"].createElement("div", {
    key: item.id,
    role: "option",
    tabIndex: 0,
    "aria-selected": selected,
    className: (0, _classnames["default"])('list-item', className, {
      disabled: disabled,
      selected: selected
    }),
    onClick: handleClick
  }, item.label);
};

DoubleClickableListItem.propTypes = {
  item: _propTypes["default"].instanceOf(Object),
  className: _propTypes["default"].string,
  onClick: _propTypes["default"].func,
  onDoubleClick: _propTypes["default"].func,
  disabled: _propTypes["default"].bool,
  selected: _propTypes["default"].bool
};

var noop = function noop() {};

exports.noop = noop;
DoubleClickableListItem.defaultProps = {
  item: {},
  className: '',
  onClick: noop,
  onDoubleClick: noop,
  disabled: false,
  selected: false
};
var _default = DoubleClickableListItem;
exports["default"] = _default;